import React, { ReactElement } from 'react'
import { l, Icon } from '@manychat/manyui'

import { ChatThreadUser } from 'apps/chat/constants/LiveChatInterfaces'
import { ISubscriber } from 'common/audience/components/UserModal/interfaces'
import { getSubscriberTitle } from 'common/audience/helpers/getSubscriberTitle'

interface SubscriberNameProps {
  subscriber: ISubscriber | ChatThreadUser
  leftIcon?: ReactElement
  className?: string
  classNameText?: string
}

export const SubscriberName = ({
  leftIcon,
  subscriber,
  className,
  classNameText,
}: SubscriberNameProps) => {
  const { tg_importing } = subscriber

  return (
    <span className={className} data-test-id="contact-name">
      {leftIcon}
      <span className={classNameText}>{getSubscriberTitle(subscriber)}</span>
      {Boolean(tg_importing) && (
        <span className="d-flex">
          <Icon.Info
            size={22}
            className="m-l-xxs text-warning"
            data-title-at="left"
            data-title={l.translate(
              "We're uploading contact's information. Meanwhile, you can send and receive messages from this contact.",
            )}
            data-title-width={180}
          />
        </span>
      )}
    </span>
  )
}
